import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Components/Table";
import { useEffect, useState } from "react";
import StickyToolbar from "../../../Components/StickyToolbar";
import FilterCliente from "./FilterCliente";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import InfoUau from "./InfoUau";
import ModalComponent from "../../../Components/Modais";
import { ListarClienteCompletoController } from "../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import { IClienteCompletoUAU } from "../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import moment from "moment";

export default function BuscaDeClientesUau() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const [lstClientes, setLstClientes] =
        useState<Array<IClienteCompletoUAU>>();
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");

    useEffect(() => {
        if (name) {
            updateClientes(name);
        }
        // eslint-disable-next-line
    }, []);

    function updateClientes(name: string) {
        setLoading(true);
        ListarClienteCompletoController(name)
            .then((response: Array<IClienteCompletoUAU>) => {
                setLstClientes(response);
                setTotalPaginas(response.length);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const tableviewColumns: Array<ColumnDescription> = [
        {
            dataField: "",
            text: "Ação",
            isDummyField: true,
            formatter: (_, row) => {
                return (
                    <>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-evento-tooltip">
                                    Visualizar
                                </Tooltip>
                            }
                        >
                            <button
                                className="m-2 btn btn-icon btn-outline-info"
                                onClick={() => {
                                    setModal({
                                        Component: () => (
                                            <InfoUau
                                                ID_CHAVE_ERP={row.cod_pes}
                                            />
                                        ),
                                        noHeader: true,
                                        noBody: true,
                                        noFooter: true,
                                        size: "xl",
                                    });
                                    setShow(true);
                                }}
                            >
                                <i className="icon-xl far fa-eye"></i>
                            </button>
                        </OverlayTrigger>
                    </>
                );
            },
        },
        {
            dataField: "nome_pes",
            text: "Nome",
        },
        {
            dataField: "dtnasc_pes",
            text: "Dt. Nascimento",
            formatter: (_, row) => {
                return <>{moment(row.dtnasc_pes).format("LL")}</>;
            },
        },
        {
            dataField: "status_pes",
            text: "Status",
        },
        {
            dataField: "cpf_pes",
            text: "CPF",
        },
    ];

    return (
        <div className="card-body bg-white rounded m-0 my-3 p-0 py-4">
            <Table
                columns={tableviewColumns}
                data={lstClientes ?? []}
                keyField="cod_pes"
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum cliente encontrado
                    </div>
                )}
                defaultStyle={{
                    align: "center",
                    classes: "p-4",
                }}
                noHover
                noSearch
                sizePerPage={10}
                bordered={false}
                loading={loading}
                totalPages={Math.ceil(totalPaginas / 10)}
                rowClasses={"rowClasses"}
            />
            <StickyToolbar
                Filters={
                    <FilterCliente
                        updateClientes={updateClientes}
                        setName={setName}
                        name={name}
                    />
                }
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
